import React from 'react'
import OurCompines from './OurCompines'
import CareerWidget from '../components/CareerWidget'
import BusinessWidget from '../components/BusinessWidget'
import AboutUsWidget from '../components/AboutWidget'
import HeroSection from '../components/HeroSection'
import ConatctWidget from '../components/ConatctWidget'

function Home() {
  return (
    <div>
      <HeroSection />
      <AboutUsWidget />
      <BusinessWidget />
      <CareerWidget />
      <OurCompines />
      <ConatctWidget />
    </div>
  )
}

export default Home